import { create } from "zustand";
import axiosInstance from "../../Components/axiosInstance/AxiosInstance";

const StoreProfileInfo = create((set) => ({
  data: [],
  loading: false,
  error: null,

  fetchData: async () => {
    set({ loading: true, error: null });
    try {
      const { data } = await axiosInstance.get("/api/me "); // Replace with your API
      console.log("profile");
      console.log(data);
      set({ data: data.data, loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },
}));

export { StoreProfileInfo };
